<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <div class="h-toolbarBg">
          <ejs-toolbar>
            <e-items>
              <e-item prefixIcon='icon hero-icon hero-icon-advanced-search' :tooltipText='$t("System.selectOprSet")' :click="setOperation"></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-business-operation' :tooltipText='$t("System.busSet")' :click="operation"></e-item>
            </e-items>
          </ejs-toolbar>
          <div class="h-inputBox">
            <input class="e-input" :placeholder="oprType == 0 ? $t('System.inputTip11'):$t('System.inputTip1')" @keyup.enter="filterData" v-model="keyString"/>
          </div>
        </div>
        <div class="h100-40 noPage">
          <ejs-grid ref="grid" height='100%' :selectionSettings='selectionOptions' :detailTemplate="detailTemplate">
            <e-columns>
              <e-column type="checkbox" width="50" textAlign="center"></e-column>
              <e-column field="operName" isPrimaryKey="true" :headerText="$t('System.itemName')" width="120" textAlign="center"></e-column>
              <e-column field="tableName" :headerText="$t('System.tableName')" width="150" textAlign="center"></e-column>
              <e-column field="updateTime" :headerText="$t('System.updateTime')" width="130" format="yMd" textAlign="center" :visible="oprType === 0 ? true : false"></e-column>
              <e-column field="neTypeName" :headerText="$t('System.neType')" width="120" format="C2" textAlign="center" :visible="oprType === 0 ? true : false"></e-column>
              <e-column field="tableRows" :headerText="$t('System.dataTotal')" width="130" textAlign="center" :visible="oprType === 1? true : false"></e-column>
              <e-column field="createTime" :headerText="$t('System.createTime')" width="120" textAlign="center" :visible="oprType === 1? true : false"></e-column>
              <e-column field="editTime" :headerText="$t('System.editTime')" width="130" textAlign="center" :visible="oprType === 1? true : false"></e-column>
              <e-column field="memorySize" :headerText="$t('System.area')" width="130" textAlign="center"></e-column>
            </e-columns>
          </ejs-grid>
          <CustomDialog ref="oprDialog" v-bind:element="oprSetDialog.element" v-bind:styles="oprSetDialog.styles">
            <OprSetDialog slot="dialog-content" @childProps="getOprMessage" v-bind:fmOrAm="oprType"></OprSetDialog>
          </CustomDialog>
          <CustomDialog ref="busDialog" v-bind:element="busSetDialog.element" v-bind:styles="busSetDialog.styles">
            <BusSetDialog ref="busSet" slot="dialog-content" @childProps="getBusMessage" v-bind:fmOrAm="oprType"></BusSetDialog>
          </CustomDialog>
          <CustomDialog ref="resultDialog" v-bind:element="resultDialog.element" v-bind:styles="resultDialog.styles">
            <template v-slot:dialog-content>
              <Result v-bind:result="busResult"></Result>
            </template>
          </CustomDialog>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import OprSetDialog from "../../components/system/OprSetDialog";
import BusSetDialog from "../../components/system/BusSetDialog";
import DetailTemp from "../../components/system/DetailTemp";
import Result from "../../components/system/Result";
import { DetailRow, Filter } from "@syncfusion/ej2-vue-grids";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "Datamanager",
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.dataManager')}/${this.$t('System.pmBusManager')}` },
      detailTemplate: function () {
        return { template: DetailTemp };
      },
      keyString: "",
      busProps: {},
      oprProps: {},
      oprType: 0, // 当前选择数据管理 0 性能/ 1 告警
      userName: "",
      busResult: [],
      constData: [],
      resultDialog: {
        element: {
          isClose: true,
          refName: "resultShow",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.resultTip')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      oprSetDialog: {
        element: {
          isClose: true,
          refName: "oprSetDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}`}
            },
            {
              click: this.confirmOpr,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.selectOprSet')}`
        },
        styles: {
          width: "500px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      busSetDialog: {
        element: {
          // target: "#app",
          isClose: true,
          refName: "busSetDia",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('System.cancel')}`}
            },
            {
              click: this.sendMessage,
              buttonModel: { content: `${this.$t('System.confirm')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('System.fm')}${this.$t('System.busSet')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      detailData: {},
      oprs: [
        { text: `${this.$t("System.onlyBackup")}`, value: "BACKUP" },
        { text: `${this.$t("System.onlyDel")}`, value: "DELETE" },
        { text: `${this.$t("System.backupAndDel")}`, value: "BACKUPANDDELETE" },
        { text: `${this.$t("System.remoteSave")}`, value: "UPLOADFTP" }
      ]
    };
  },
  components: {
    BasicLayout,
    CustomDialog,
    OprSetDialog,
    BusSetDialog,
    DetailTemp,
    Result
  },
  methods: {
    filterData() {
      if (this.constData == null) {
        return null;
      }
      let filterData = [];
      this.constData.forEach(e => {
        if (
          e.operName.indexOf(this.keyString) != -1 ||
          e.tableName.indexOf(this.keyString) != -1 ||
          (e.updateTime != null &&
            e.updateTime.indexOf(this.keyString) != -1) ||
          (e.createTime != null && e.createTime.indexOf(this.keyString) != -1)
        ) {
          filterData.push(e);
        }
      });
      this.$refs.grid.ej2Instances.dataSource = filterData;
    },
    setOperation() {
      this.$refs.oprDialog.show();
    },
    operation() {
      const result = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (result == null || result == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectMessages')});
        return null;
      }
      this.$refs.busDialog.show();
      this.$refs.busSet.bindValidate();
    },
    dialogHide() {
      this.$refs.oprDialog.clear();
      this.$refs.busDialog.clear();
      this.$refs.resultDialog.clear();
      this.$refs.oprDialog.close();
      this.$refs.busDialog.close();
      this.$refs.resultDialog.close();
    },
    getBusMessage(data) {
      this.busProps = data;
    },
    getOprMessage(data) {
      this.oprProps = data;
    },
    confirmOpr() {
      this.$refs.oprDialog.clear();
      this.$refs.oprDialog.close();
      const url = "/lte/ems/sysmanager/task/getEnumList/";
      if (this.oprProps == null) {
        return null;
      }
      const params = {
        moduleId: this.oprProps.moduleId,
        setIdLst: this.oprProps.setIdLst
      };
      this.$loading.showLoadding(`${this.$t('MML.loadingTip')}`);
      this.axios.post(url, params).then(response => {
        this.$loading.hideLoadding();
        this.constData = response.data;
        this.$refs.grid.ej2Instances.dataSource = this.constData;
      });
    },
    sendMessage() {
      const result = this.$refs.grid.ej2Instances.getSelectedRecords();
      let isBackupZip = new Boolean();
      isBackupZip = this.busProps.operType !== 'DELETE';
      if (isBackupZip) {
        const validate = this.$refs.busSet.validate();
        if (!validate) {
          return null;
        }
      }
      const params = {
        moduleId: result[0].moduleId,
        operAttr: this.busProps.operAttr,
        operLst: result,
        operType: this.busProps.operType,
        userName: this.userName
      };
      if (this.oprType === 0) {
        if (params.operAttr.backupTime === '') {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.backDelTime')});
          return null;
        }
      } else {
        if (params.operAttr.backupTime === '' && params.operAttr.operStyle === 'byTime') {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.backDelTime')});
          return null;
        }
        if (params.operAttr.backupCapacity === '' && params.operAttr.operStyle === 'byCapacity') {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('System.backDelRange')});
          return null;
        }
      }
      this.$loading.showLoadding(`${this.$t('System.processing')}`);
      let url = "/lte/ems/sysmanager/task/execBusinessOper/";
      this.axios.post(url, params,{timeout: 60 * 4 * 1000}).then(response => {
        const re = response.data;
        this.busResult = [];
        let packageResult = 0;
        re.forEach(item => {
          if(item.operName !== 'PACKAGE'){
            const se = item;
            const op = this.oprs.filter(it => it.value === item.operName);
            se['operName'] = op[0]['text'];
            if (item['result'] == -1) {
              se['result'] = this.$t('System.reFault');
            } else {
              se['result'] = this.$t('System.reSuccess');
            }
            this.busResult.push(se);
          }else{
            packageResult = item.result;
          }
        });
        this.$refs.busDialog.clear();
        this.$refs.busDialog.close();
        this.$loading.hideLoadding();
        this.$refs.resultDialog.show();
        // 保存备份文件
        if (isBackupZip && packageResult == 1) {
          const pkg = re.filter(item => item.operName === 'PACKAGE');
          if(pkg.length > 0){
            url = '/lte/ems/sysmanager/task/sysDataDownload';
            let paramstring = '?moduleId=' + params.moduleId + '&filename=' + pkg[0].returnDate;
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url + paramstring;
            document.body.appendChild(link);
            link.click();
          }
        }
      }).catch(error =>{
        this.$loading.hideLoadding();
        EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
      });
    },
    setBasicTitle() {
      let id = this.$route.params.id;
      if (id === "1") {
        this.right.crumb = `${this.$t('System.systemManager')}/${this.$t('System.dataManager')}/${this.$t('System.pmBusManager')}`;
        this.oprType = 0;
        this.sysOrCustom = 0;
        this.$refs.grid.ej2Instances.dataSource = [];
        this.busSetDialog.element.title = `${this.$t('System.fm')}${this.$t('System.busSet')}`;
        setTimeout(()=> {
          const temp = this.$refs.grid.$el.childNodes[2].firstChild.firstChild.childNodes[1].firstChild.childNodes[1].firstChild.firstChild;
          if (temp) {
            temp.classList.remove('e-checkbox-disabled');
          }
        }, 100);
      } else {
        this.right.crumb = `${this.$t('System.systemManager')}/${this.$t('System.dataManager')}/${this.$t('System.alarmBusManager')}`;
        this.oprType = 1;
        this.sysOrCustom = 1;
        this.$refs.grid.ej2Instances.dataSource = [];
        this.busSetDialog.element.title = `${this.$t('System.alarm')}${this.$t('System.busSet')}`;
        setTimeout(()=> {
          const temp = this.$refs.grid.$el.childNodes[2].firstChild.firstChild.childNodes[1].firstChild.childNodes[1].firstChild.firstChild;
          if (temp) {
            temp.classList.remove('e-checkbox-disabled');
          }
        }, 100);
      }
    }
  },
  mounted() {
    this.setBasicTitle();
  },
  watch: {
    $route(to, from) {
      this.setBasicTitle();
    }
  },
  provide: {
    grid: [DetailRow, Filter]
  }
};
</script>

<style>

</style>
